import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { KesariDot } from './ui/Ornaments';
export const ProgramJourney = () => {
  const stages = [{
    numeral: 'I',
    gurmukhiNum: '੧',
    title: 'Discover',
    essence: 'Map the root causes of real civic issues.',
    bullets: ['Stakeholder mapping', 'Root cause analysis', 'Systems thinking'],
    day: 'Saturday 1'
  }, {
    numeral: 'II',
    gurmukhiNum: '੨',
    title: 'Design',
    essence: 'Build a viable, scalable solution.',
    bullets: ['AI-assisted research', 'Venture design', 'Prototyping'],
    day: 'Saturday 2'
  }, {
    numeral: 'III',
    gurmukhiNum: '੩',
    title: 'Deliver',
    essence: 'Pitch to real leaders and investors.',
    bullets: ['Public speaking', 'Pitch deck creation', 'Feedback integration'],
    day: 'Saturday 3'
  }];
  return <section id="program" className="py-24 md:py-32 bg-parchment relative" data-id="element-211">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-212" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-213">
        <SectionHeader title="The Journey" subtitle="Three intensive Saturdays designed to take you from identifying a problem to pitching a solution." centered data-id="element-214" />

        <div className="relative mt-20" data-id="element-215">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-[1px] bg-bronze/20 -translate-y-1/2" data-id="element-216" />
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} className="hidden md:block absolute top-1/2 left-0 right-0 h-[1px] bg-gradient-to-r from-gold via-kesari to-gold origin-left -translate-y-1/2 shadow-[0_0_10px_rgba(212,118,60,0.3)]" data-id="element-217" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-218">
            {stages.map((stage, idx) => <motion.div key={stage.numeral} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: idx * 0.2
          }} whileHover={{
            y: -10
          }} className="group bg-ivory border border-bronze/20 p-8 rounded-sm hover:border-kesari hover:shadow-[0_15px_40px_rgba(212,118,60,0.1)] transition-all duration-500 relative" data-id="element-219">
                <div className="absolute -top-6 left-8 bg-navy text-gold font-serif text-xl w-14 h-14 flex items-center justify-center rounded-sm border border-gold/30 group-hover:border-kesari group-hover:text-kesari transition-colors shadow-lg overflow-hidden" data-id="element-220">
                  <span className="relative z-10 flex items-center gap-1" data-id="element-221">
                    {stage.numeral}
                    <span className="font-gurmukhi text-xs opacity-50" data-id="element-222">
                      {stage.gurmukhiNum}
                    </span>
                  </span>
                  <div className="absolute inset-0 bg-kesari/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-223" />
                </div>

                <div className="mt-8" data-id="element-224">
                  <div className="flex items-center gap-2 mb-2" data-id="element-225">
                    <KesariDot className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-226" />
                    <div className="text-xs font-sans text-gold group-hover:text-kesari transition-colors font-semibold tracking-wider uppercase" data-id="element-227">
                      {stage.day}
                    </div>
                  </div>
                  <h3 className="font-serif text-3xl text-navy mb-3" data-id="element-228">
                    {stage.title}
                  </h3>
                  <p className="font-sans text-charcoal/80 mb-6 font-medium" data-id="element-229">
                    {stage.essence}
                  </p>

                  <ul className="space-y-3" data-id="element-230">
                    {stage.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3 text-sm font-sans text-charcoal/70" data-id="element-231">
                        <span className="text-kesari mt-1 text-xs" data-id="element-232">✦</span>
                        {bullet}
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};